<script>
import CHeader from "@/components/c-header/c-header.vue";
import HsScroll from "@/base/hs-scroll/hs-scroll.vue";
import NameExplain from "@/pages/personal/passengers/nameExplain.vue";
import NameInfo from "@/pages/personal/passengers/passenger-details/details-name-info.vue";
import DetailsNameInfo from "@/pages/personal/passengers/passenger-details/details-name-info.vue";
import mixinDes from "@/common/mixin/passenger/mixin-des";
import DetailsOtherInfo from "@/pages/personal/passengers/passenger-details/details-other-info.vue";
import DetailsCompanyInfo from "@/pages/personal/passengers/passenger-details/details-company-info.vue";
import DetailsTravellerCard from "@/pages/personal/passengers/passenger-details/details-traveller-card.vue";
import DetailsNoticeInfo from "@/pages/personal/passengers/passenger-details/details-notice-info.vue";
import DetailsSubmitNoticeInfo from "@/pages/personal/passengers/passenger-details/details-submit-notice-info.vue";
import {kpiFrequentTravelerAdd, kpiFrequentTravelerDelete, kpiFrequentTravelerPut} from "@/api";
import HsButton from "@/base/hs-button/hs-button.vue";
import {getMarkClassName} from "@/pages/personal/passengers/passenger-details/details";
import {getRect} from "@/common/js/dom";

export default {
  props: {
    XOrder: {
      type: Object,
      default: function() {
        return {}
      }
    },
    details: {
      type: Object,
      default: function () {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
    BookingLimit: {
      type: Object,
      default: () => {
        return null
      }
    },
    /* 是否在组件内关闭 */
    isClose: {
      type: Boolean,
      default: false
    },
    IsNotSave: { // 编辑 是否调用ajax保存
      type: Boolean,
      default: false
    },
    ExpirationTime: {
      type: String,
      default: null
    },
    isNotShowNickName: { // 是否不展示昵称 针对国际机票需求单 后端暂不支持昵称
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      submitChecked: false,
      currentDetails: {},
      detailsSubmitNoticeInfoClass: getMarkClassName('detailsSubmitNoticeInfo'),
      /** 证件 */
      credential: {
        CredentialName: '',
        CredentialType: '',
        CredentialNo: '',
        EffectiveDate: '',
        CredentialNation: 0, // 0 不显示 1 显示 2必填
        PsgNation: 0, // 0 不显示 1 显示 2必填
        ExpireDateSetting: 0, // 0 不显示 1 显示 2必填
        NameType: -1, // -1不限 0中文 1英文
        Nation: null
      },
      credentialList: [], // 平铺证件列表
      // credential: null,

      chinaNation: {
        ID: '369f3545-9e79-4f32-82a5-a15c01244b52',
        Code: 'CN',
        Name: this.language === 'EN' ? 'CHINA' : '中国',
        ThreeCharCode: 'CHN'
      }, // 默认中国国籍数据

      isReadAndAgree: true,

      powerDetails: {
        title: '', // 标题
        showDefaultNameType: true, // 展示中英姓名切换

        showCredentialList: false, // 证件列表平铺_展示 长旅客详情证件列表平铺展示
        showCredential: true, // 证件_展示
        requiredCredential: false, // 证件_必填

        showEffectiveDate: false, // 证件有效期_展示
        requiredEffectiveDate: false, // 证件有效期_必填

        showCredentialNation: false, // 展示证件签署国
        requiredCredentialNation: false, // 展示证件签署国 是否必填
        showNation: false, // 国籍_展示
        requiredNation: false, // 国籍_必填

        showBirthday: false, // 出生日期_展示
        requiredBirthday: false, // 出生日期_必填

        showGender: false, // 性别_展示
        requiredGender: false, // 性别_必填

        requiredMobile: true, // 手机号_必填

        showCard: false, // 常旅客卡_展示
        showHotelCard: false // 酒店集团会员卡_展示
      },
    }
  },
  mixins: [mixinDes],
  watch: {
    show(val) {
      if (val) {
        this.submitBtn = false
        this.isReadAndAgree = true
        this.submitChecked = false
        this.currentDetails = JSON.parse(JSON.stringify(this.details))
        this.credential = {
          CredentialName: '',
          CredentialType: '',
          CredentialNo: '',
          EffectiveDate: '',
          CredentialNation: 0, // 0 不显示 1 显示 2必填
          PsgNation: 0, // 0 不显示 1 显示 2必填
          ExpireDateSetting: 0, // 0 不显示 1 显示 2必填
          NameType: -1, // -1不限 0中文 1英文
          Nation: null
        }

        // 常旅客以外其他地方处理性别、出生日期、国籍
        if (this.OrderBusinessType !== 0) {
          // 设置正确的证件
          if (this.details.Credentials && this.details.Credentials.filter(v => v.CredentialType === this.details.DefaultCredentialType)[0]) {
            this.credential = this._cloneFun(this.details.Credentials.filter(v => v.CredentialType === this.details.DefaultCredentialType)[0])
            this.credential.EffectiveDate === '1900-01-01' && (this.credential.EffectiveDate = '')
          }
        }
        // 新增 设置默认国籍
        if (this.currentDetails.index === undefined || this.currentDetails.index === null || this.currentDetails.index < 0) {
          this._setDefaultNation()
        }
        // 根据证件初始化 国籍、出生日期、性别
        this._initPowerDetails()
        // 如果是常旅客管理 则初始化证件列表
        if (this.powerDetails.showCredentialList) { // 如果是证件列表平铺展示 则初始化证件列表数据
          this.credentialList = this.currentDetails.Credentials ? this.currentDetails.Credentials.filter(v => v.CredentialNo) : []
          if (this.credentialList.length <= 0 && this.currentDetails.Credentials && this.currentDetails.Credentials[0]) {
            this.credentialList = [{
              ...this.currentDetails.Credentials[0]
            }]
          }
        } else {
          this.credentialList = []
        }

        this._setBirthdayAndGender(this.credential.CredentialNo)
      }
    },
    'credential.CredentialNo': {
      handler(val) {
        this.OrderBusinessType !== 0 && this._setBirthdayAndGender(val)
      },
      deep: true
    },
    'credential.CredentialType': {
      handler(val) {
        this._updatePowerDetails(val)
      },
      deep: true
    },
  },
  methods: {
    open() {
      this.show = true
    },
    close(type) {
      if (type !== 'reset' && this._checkPassengerDetailsIsChange()) {
        this.$alert({
          type: 'new',
          content: this.$t('AreYouSureToCancelUnableToSave'),
          cancelTxt: this.$t('CancelAnyway'),
          confirmTxt: this.$t('Save'),
          cancelFn: () => {
            this.close('reset')
          },
          confirmFn: () => {
            this._localCheck()
          }
        })
      } else {
        this.show = false
      }
    },
    /** 根据板块初始化页面权限 */
    _initPowerDetails() {
      // 常旅客
      if (this.OrderBusinessType === 0) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('FrequentTraveler') + `(${this.currentDetails.TravelType === 0 ? this.$t('Business') : this.$t('Personal')})`
        } else if (this.currentDetails.TravelType === 0) {
          this.powerDetails.title = this.$t('AddBusiness')
        } else if (this.currentDetails.TravelType === 1) {
          this.powerDetails.title = this.$t('AddPersonal')
        }
        this.powerDetails.showCredential = false
        this.powerDetails.showCredentialList = true
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.showDefaultNameType = false
        this.powerDetails.showNation = true
        this.powerDetails.showBirthday = true
        this.powerDetails.showGender = true
        this.powerDetails.showCard = true
        this.powerDetails.showHotelCard = true
        // 国内机票
      } else if (this.OrderBusinessType === 1) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerFlight')
        } else {
          this.powerDetails.title = this.$t('NewPassengerFlight')
        }
        // this.powerDetails.showEffectiveDate = true
        // this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.requiredCredential = true
        this.powerDetails.showGender = true
        this.powerDetails.requiredGender = true
        this.powerDetails.showBirthday = true
        this.powerDetails.requiredBirthday = true
        this.powerDetails.showCard = false
        this.powerDetails.showHotelCard = false
        // 国际机票
      } else if (this.OrderBusinessType === 6) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerFlight')
        } else {
          this.powerDetails.title = this.$t('NewPassengerFlight')
        }
        this.powerDetails.showDefaultNameType = false
        this.powerDetails.requiredCredential = true
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.showNation = true
        this.powerDetails.requiredNation = true
        this.powerDetails.showBirthday = true
        this.powerDetails.showGender = true
        this.powerDetails.requiredGender = true
        this.powerDetails.requiredBirthday = true
        this.powerDetails.showCard = false
        this.powerDetails.showHotelCard = false
        // 国内酒店
      } else if (this.OrderBusinessType === 2) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('Roomer')
        } else {
          this.powerDetails.title = this.$t('NewRoomer')
        }
        // 不需要证件 则不展示证件
        if (!this.BookingLimit) {
          this.powerDetails.showCredential = true
          this.powerDetails.requiredCredential = false
        } else if (this.BookingLimit && this.BookingLimit.LimitIdentityType !== 1) {
          this.powerDetails.showCredential = false
          this.powerDetails.requiredCredential = false
        } else {
          this.powerDetails.showCredential = true
          this.powerDetails.requiredCredential = true
        }
        // 国际酒店
      } else if (this.OrderBusinessType === 11) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('Roomer')
        } else {
          this.powerDetails.title = this.$t('NewRoomer')
        }
        this.powerDetails.showDefaultNameType = false
        this.powerDetails.showCredential = false
        // 火车票
      } else if (this.OrderBusinessType === 10) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerVehicle')
        } else {
          this.powerDetails.title = this.$t('NewPassengerVehicle')
        }
        this.powerDetails.requiredCredential = true
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.showNation = true
        // this.powerDetails.requiredNation = true
        this.powerDetails.showBirthday = true
        this.powerDetails.requiredBirthday = true
        // this.powerDetails.showGender = true
        // 用车
      } else if (this.OrderBusinessType === 14) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerVehicle')
        } else {
          this.powerDetails.title = this.$t('NewPassengerVehicle')
        }
        this.powerDetails.showCredential = false
      } else if (this.OrderBusinessType === 15) {
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('Diner')
        } else {
          this.powerDetails.title = this.$t('NewDiner')
        }
        this.powerDetails.showCredential = false
      } else if (this.OrderBusinessType === 17) { // 出差申请单
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('Traveler')
        } else {
          this.powerDetails.title = this.$t('NewTraveler')
        }
        this.powerDetails.requiredMobile = true
        this.powerDetails.showCredential = false
      } else if (this.OrderBusinessType === 18) { // 汽车票
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerVehicle')
        } else {
          this.powerDetails.title = this.$t('NewPassengerVehicle')
        }
        this.powerDetails.requiredCredential = true
        this.powerDetails.requiredMobile = true
      } else if (this.OrderBusinessType === 10006) { // 国际机票询价单
        if (this.currentDetails.index >= 0) {
          this.powerDetails.title = this.$t('PassengerFlight')
        } else {
          this.powerDetails.title = this.$t('NewPassengerFlight')
        }
        this.powerDetails.showDefaultNameType = false
        this.powerDetails.requiredCredential = true
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.showNation = true
        this.powerDetails.requiredNation = true
        this.powerDetails.showBirthday = true
        this.powerDetails.showGender = true
        this.powerDetails.requiredGender = true
        this.powerDetails.requiredBirthday = true
        this.powerDetails.showCard = false
        this.powerDetails.showHotelCard = false
      }

      // 订单预订板块标题添加因公/因私
      if (this.OrderBusinessType !== 0 && this.OrderBusinessType !== 17) {
        this.powerDetails.title += `(${this.currentDetails.TravelType === 0 ? this.$t('Business') : this.$t('Personal')})`
      }

      let BookingLimit = this.BookingLimit // 特殊的姓名限制
      // 0 不限 1 中文 2 英文
      if (BookingLimit && BookingLimit.LimitNameType) {
        this.powerDetails.showDefaultNameType = false
      }
      this._updatePowerOfCredentialNationWithCredentialType()
    },

    /** 根据证件类型切换 更新证件有效期 国籍的显示隐藏 */
    _updatePowerDetails() {
      let isIdCard = this.credential.CredentialType === 1 // 是否是身份证
      // 常旅客
      if (this.OrderBusinessType === 0) {
        // this.powerDetails.showEffectiveDate = true
        // this.powerDetails.showNation = true
        this.powerDetails.showCredentialNation = true
        // 国内机票
      } else if (this.OrderBusinessType === 1) {
        // this.powerDetails.showEffectiveDate = true
        // this.powerDetails.requiredEffectiveDate = true

        // 国际机票
      } else if (this.OrderBusinessType === 6) {
        // this.powerDetails.showEffectiveDate = true
        // this.powerDetails.requiredEffectiveDate = true
        // this.powerDetails.showNation = true
        // 国内酒店
      } else if (this.OrderBusinessType === 2) {
        // 国际酒店
      } else if (this.OrderBusinessType === 11) {
        // 火车票
      } else if (this.OrderBusinessType === 10) {
        if (isIdCard) {
          this.powerDetails.showEffectiveDate = false
          this.powerDetails.requiredEffectiveDate = false
          this.powerDetails.showNation = false
        } else {
          this.powerDetails.showEffectiveDate = true
          this.powerDetails.requiredEffectiveDate = true
          this.powerDetails.showNation = true
        }
        this.currentDetails.Nation = this.details.Nation
        // this.credential.EffectiveDate = ''
        // 用车
      } else if (this.OrderBusinessType === 14) {
      } else if (this.OrderBusinessType === 15) { // 用餐
      }
      this._updatePowerOfCredentialNationWithCredentialType()
    },

    _updatePowerOfCredentialNationWithCredentialType() {
      // 根据证件类型里对应的字段更新是否现在是是否必填 // -1不限 0中文 1英文
      let NameType = Number(this.credential.NameType)
      if (NameType === 0) {
        this.powerDetails.showDefaultNameType = false
        this.currentDetails.DefaultNameType = 0
      } else if (NameType === 1) {
        this.powerDetails.showDefaultNameType = false
        this.currentDetails.DefaultNameType = 1
      } else {
        if (this.OrderBusinessType === 6 || this.OrderBusinessType === 11) {
          this.powerDetails.showDefaultNameType = false
        } else {
          this.powerDetails.showDefaultNameType = true
        }
        // this.powerDetails.showDefaultNameType = true
        // this.currentDetails.DefaultNameType = this.details.DefaultNameType
      }

      // 根据证件类型里对应的字段更新是否现在是是否必填 证件签署国 // 0 不显示 1 显示 2必填
      let CredentialNation = Number(this.credential.CredentialNation)
      if (CredentialNation === 1) {
        this.powerDetails.showCredentialNation = true
        this.powerDetails.requiredCredentialNation = false
      } else if (CredentialNation === 2) {
        this.powerDetails.showCredentialNation = true
        this.powerDetails.requiredCredentialNation = true
      } else {
        this.powerDetails.showCredentialNation = false
        this.powerDetails.requiredCredentialNation = false
      }

      // 根据证件类型里对应的字段更新是否现在是是否必填 国籍 // 0 不显示 1 显示 2必填
      // 常旅客详情 默认显示国籍展示没必填
      let PsgNation = Number(this.credential.PsgNation)
      if (PsgNation === 1 || Number(this.OrderBusinessType) === 0) {
        this.powerDetails.showNation = true
        this.powerDetails.requiredNation = false
      } else if (PsgNation === 2) {
        this.powerDetails.showNation = true
        this.powerDetails.requiredNation = true
      } else {
        this.powerDetails.showNation = false
        this.powerDetails.requiredNation = false
      }

      // 证件有效期 国籍 // 0 不显示 1 显示 2必填
      let ExpireDateSetting = this.credential ? Number(this.credential.ExpireDateSetting) : 0 // 证件有效期 0 不显示 1 显示 2必填
      if (ExpireDateSetting === 1) {
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.requiredEffectiveDate = false
      } else if (ExpireDateSetting === 2) {
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.requiredEffectiveDate = true
      } else {
        this.powerDetails.showEffectiveDate = false
        this.powerDetails.requiredEffectiveDate = false
      }
    },

    _checkPassengerDetailsIsChange() {
      let currentDetails = this._cloneFun(this.currentDetails)
      let details = this._cloneFun(this.details)
      let list = [
        'ChName', 'LastName', 'FirstName', 'NickName',
        'MobileCountryCode', 'Mobile', 'Email', 'UpType', 'EmployeeNo',
        'ExtendField1', 'ExtendField2', 'ExtendField3', 'ExtendField4', 'ExtendField5',
        'IsSendBookSms', 'IsSendIssuedSms', 'IsSendBookEmail', 'IsSendIssuedEmail', 'IsSendConfirmSms', 'IsSendConfirmEmail'
      ]

      if (this.powerDetails.showBirthday) {
        list.push('Birthday')
      }
      if (this.powerDetails.showGender) {
        list.push('NewGender')
      }

      for (let i = 0, len = list.length; i < len; i++) {
        let key = list[i]
        if (!currentDetails[key] && !details[key]) {
          console.log('未更改')
        } else if (currentDetails[key] !== details[key]) {
          return true
        }
      }

      if (this.powerDetails.showCredentialList) { // 证件平铺展示
        let oldCredentials = details.Credentials && details.Credentials.filter(v => v.CredentialNo)
        if (oldCredentials && oldCredentials.length <= 0) {
          oldCredentials = [{
            ...details.Credentials[0]
          }]
        }
        let credentialList = this.credentialList
        if (JSON.stringify(credentialList) !== JSON.stringify(oldCredentials)) {
          return true
        }
      } else {
        // 身份证信息比较
        let credential = {
          CredentialName: '',
          CredentialType: '',
          CredentialNo: '',
          EffectiveDate: '',
          CredentialNation: 0, // 0 不显示 1 显示 2必填
          PsgNation: 0, // 0 不显示 1 显示 2必填
          ExpireDateSetting: 0, // 0 不显示 1 显示 2必填
          NameType: -1, // -1不限 0中文 1英文
          Nation: null
        }
        if (details.Credentials && details.Credentials.filter(v => v.CredentialType === this.details.DefaultCredentialType)[0]) {
          credential = this._cloneFun(details.Credentials.filter(v => v.CredentialType === details.DefaultCredentialType)[0])
          credential.EffectiveDate === '1900-01-01' && (credential.EffectiveDate = '')
        }
        if (JSON.stringify(this.credential) !== JSON.stringify(credential)) {
          return true
        }
      }

      // 国籍 新增默认国籍中国 比较时初始化默认国籍
      if (this.currentDetails.index === undefined || this.currentDetails.index === null || this.currentDetails.index < 0) {
        if (this.chinaNation.Code) {
          details.Nation = {
            ...this.chinaNation
          }
        }
      }

      // 性别、出生日期、国籍 只有展示的返回才提示更改
      if (
          this.powerDetails.showNation &&
          JSON.stringify(this.currentDetails.Nation) !== JSON.stringify(details.Nation)
      ) {
        return true
      }

      // 成本中心
      if (JSON.stringify(this.currentDetails.CostCenter) !== JSON.stringify(details.CostCenter)) {
        return true
      }

      // 部门
      if (JSON.stringify(this.currentDetails.Department) !== JSON.stringify(details.Department)) {
        return true
      }

      // BU
      if (JSON.stringify(this.currentDetails.BusinessUnit) !== JSON.stringify(details.BusinessUnit)) {
        return true
      }

      // 常旅卡
      let TravelCardList = (this.currentDetails.TravelCardList || []).map(v => {
        return {
          AirLineCode: v.AirLineCode,
          AirLineName: v.AirLineName,
          CardNo: v.CardNo,
          AirLineLogoUrl: v.AirLineLogoUrl
        }
      })
      let oldTravelCardList = (details.TravelCardList || []).map(v => {
        return {
          AirLineCode: v.AirLineCode,
          AirLineName: v.AirLineName,
          CardNo: v.CardNo,
          AirLineLogoUrl: v.AirLineLogoUrl
        }
      })
      if (
          ((TravelCardList && TravelCardList.length > 0) || (oldTravelCardList && oldTravelCardList.length > 0)) &&
          JSON.stringify(TravelCardList) !== JSON.stringify(oldTravelCardList)) {
        return true
      }

      // 酒店集团会员卡
      let HotelGroupCardList = this._handleHotelGroupCardList(this.currentDetails.HotelGroupCardList || [])
      let oldHotelGroupCardList = this._handleHotelGroupCardList(details.HotelGroupCardList || [])
      if (
          ((HotelGroupCardList && HotelGroupCardList.length > 0) || (oldHotelGroupCardList && oldHotelGroupCardList.length > 0)) &&
          JSON.stringify(HotelGroupCardList) !== JSON.stringify(oldHotelGroupCardList)) {
        return true
      }

      return false
    },

    /** 处理酒店会员卡数据 */
    _handleHotelGroupCardList(list) {
      return (list || []).map(v => {
        return {
          Name: v.Name,
          Code: v.Code,
          CardNo: v.CardNo,
        }
      })
    },

    // 初始化时 如果身份证正确 则 根据身份证 设置 国际 性别 出生日期
    _setBirthdayAndGender(val) {
      console.log('进来了: ', val)
      if (this.credential.CredentialType === 1) {
        if (this.idCard(val).valid) {
          // 利用出生日期选择器的回调方法设置出生日期
          this.currentDetails.Birthday = this.beTime(this.calBirthDate(val))
          // 设置性别
          let NewGender = this.calGender(val)
          if (NewGender === 1) {
            this.currentDetails.NewGender = 1
          } else if (NewGender === 2) {
            this.currentDetails.NewGender = 2
          }
          this._setDefaultNation()
        }
      } else {
        let list = this.OrderBusinessType === 0 ? this.credentialList : this.currentDetails.Credentials
        let sel = list ? list.find(m => m.CredentialType === 1) : null
        let val = sel ? sel.CredentialNo : ''
        if (this.idCard(val).valid) {
          this.currentDetails.Birthday = this.beTime(this.calBirthDate(val))
          // 设置性别
          let NewGender = this.calGender(val)
          if (NewGender === 1) {
            this.currentDetails.NewGender = 1
          } else if (NewGender === 2) {
            this.currentDetails.NewGender = 2
          }
          this._setDefaultNation()
        }
      }
    },

    /** 如果有身份证 出生日期、性别、国籍 和身份证解析的信息不一致， 提示重置 */
    _ifHasRightIdCardSetInfoTips() {
      let Credentials = this.credentialList.filter(v => v.CredentialNo)
      let IdCard = ''
      // 利用出生日期选择器的回调方法设置出生日期
      let Birthday = this.currentDetails.Birthday
      // 设置性别
      let NewGender = this.currentDetails.NewGender
      if (this.powerDetails.showCredentialList) {
        Credentials = this.credentialList.filter(v => v.CredentialNo)
        IdCard = Credentials.find(v => v.CredentialType === 1) ? Credentials.find(v => v.CredentialType === 1).CredentialNo : ''
        if (IdCard && this.idCard(IdCard).valid) {
          // 利用出生日期选择器的回调方法设置出生日期
          Birthday = this.beTime(this.calBirthDate(IdCard))
          // 设置性别
          NewGender = this.calGender(IdCard)
        }
      } else {
        if (this.credential.CredentialType === 1) {
          IdCard = this.credential.CredentialNo
          if (IdCard && this.idCard(IdCard).valid) {
            // 利用出生日期选择器的回调方法设置出生日期
            Birthday = this.beTime(this.calBirthDate(IdCard))
            // 设置性别
            NewGender = this.calGender(IdCard)
          }
        } else {
          let Credentials = this.currentDetails.Credentials
          IdCard = Credentials.find(v => v.CredentialType === 1) ? Credentials.find(v => v.CredentialType === 1).CredentialNo : ''
          if (IdCard && this.idCard(IdCard).valid) {
            // 利用出生日期选择器的回调方法设置出生日期
            Birthday = this.beTime(this.calBirthDate(IdCard))
            // 设置性别
            NewGender = this.calGender(IdCard)
          }
        }
      }

      if (
          IdCard &&
            (Birthday !== this.currentDetails.Birthday ||
            NewGender !== this.currentDetails.NewGender ||
            (this.currentDetails.Nation && this.currentDetails.Nation.ID.toLowerCase() !== this.chinaNation.ID.toLowerCase())
          )
      ) {
        this.$alert({
          type: 'new',
          content: this.$t('YourDateOfBirthGenderNationalityAndIDCardDoNotMatch_1'),
          confirmTxt: this.$t('AutoCorrect'),
          cancelTxt: this.$t('ToModify'),
          confirmFn: () => {
            this.currentDetails.Birthday = Birthday
            this.currentDetails.NewGender = NewGender
            this.currentDetails.Nation = {
              ...this.chinaNation
            }
          }
        })
        return true
      }
    },

    /** 本地验证 */
    _localCheck() {
      this.submitChecked = true
      // 业务下单时 根据当前姓名类型 重置 其他姓名
      if (this.OrderBusinessType !== 0) {
        // 0 中文 1 英文
        if (this.currentDetails.DefaultNameType === 0) {
          this.currentDetails.LastName = this.details.LastName
          this.currentDetails.FirstName = this.details.FirstName
        } else if (this.currentDetails.DefaultNameType === 1) {
          this.currentDetails.ChName = this.details.ChName
        }
      }
      this.$nextTick(() => {
        let scrollElementsClass = ''
        if (this.$refs.refDetailsNameInfo) {
          scrollElementsClass = scrollElementsClass || this.$refs.refDetailsNameInfo.localCheck()
        }

        if (this.$refs.refDetailsOtherInfo) {
          scrollElementsClass = scrollElementsClass || this.$refs.refDetailsOtherInfo.localCheck()
        }

        if (this.$refs.refDetailsCompanyInfo) {
          scrollElementsClass = scrollElementsClass || this.$refs.refDetailsCompanyInfo.localCheck()
        }

        if (!this.isReadAndAgree) {
          !scrollElementsClass && this.$toast(this.$t('HsTravelerExplainTitle'));
          scrollElementsClass = scrollElementsClass || this.detailsSubmitNoticeInfoClass
        }

        if (scrollElementsClass) {
          let el = document.querySelector('.' + scrollElementsClass)
          this.$refs.refTableView && this.$refs.refTableView.scrollToElement(
              el,
              300,
              0,
              -getRect(this.$refs.refTableView.$el).height / 3, // 垂直居中：偏移容器高度的一半
          );
          return
        }

        if (this._ifHasRightIdCardSetInfoTips()) {
          return
        }

        this._confirm()
      })
    },

    // 提交确认
    _confirm() {
      if (this.submitBtn) {
        return
      } else {
        this.submitBtn = true
        setTimeout(() => {
          this.submitBtn = false
        }, 500)
      }
      // 组装证件信息
      if (this.credential && this.credential.CredentialType) {
        let index = this.currentDetails.Credentials.map(v => v.CredentialType).indexOf(this.credential.CredentialType)
        this.currentDetails.Credentials.splice(index, 1, this.credential)
        this.currentDetails.DefaultCredentialType = this.credential.CredentialType
        // 兼容一些老的数据结构
        this.currentDetails.Credential = this.credential
      }
      this.currentDetails.OrderBusinessType = this.OrderBusinessType
      if (this.OrderBusinessType === 10006) { // 询价单获取常旅客按国籍机票的类型请求 10006 => 6
        this.currentDetails.OrderBusinessType = 6
      }

      this.currentDetails.Name = this.currentDetails.DefaultNameType === 0 ? this.currentDetails.ChName : `${this.currentDetails.LastName}/${this.currentDetails.FirstName}`
      if (this.powerDetails.showCredentialList) { // 如果是证件列表修改则证件列表赋值并保存
        this.currentDetails.Credentials = (this.currentDetails.Credentials || []).map(v => {
          let item = this.credentialList.find(m => Number(m.CredentialType) === Number(v.CredentialType))
          item = item || {}
          return {
            ...v,
            ...item,
            CredentialNo: item.CredentialNo || '',
            EffectiveDate: item.EffectiveDate || '',
            Nation: item.Nation || null
          }
        })
      }
      let HotelGroupCardList = (this.currentDetails.HotelGroupCardList || []).filter(v => v.CardNo)
      let TravelCardList = (this.currentDetails.TravelCardList || []).filter(v => v.CardNo)
      this._delegateWithPassengerDetails({
        ...this.currentDetails,
        HotelGroupCardList,
        TravelCardList
      })
    },

    /** 常旅客 新增 保存 */
    _delegateWithPassengerDetails(item) {
      let params = item
      params.OrderBusinessType = this.OrderBusinessType
      if (this.OrderBusinessType === 10006) { // 询价单获取常旅客按国籍机票的类型请求 10006 => 6
        params.OrderBusinessType = 6
      }
      // 编辑常旅客详情
      if (item.index >= 0) {
        if (this.IsNotSave) {
          this._sendEmitMessage(item)
        } else {
          kpiFrequentTravelerPut(params).then((res) => {
            console.log('修改: ', res)
            if (res.ResultData === true) {
              this.$toast(this.$t('SaveSucceed'))
              this._sendEmitMessage(item)
            } else {
              this.$toast(this.$t('SaveFailed'))
            }
          })
        }
      } else {
        kpiFrequentTravelerAdd(params).then((res) => {
          console.log('常旅客添加: ', res)
          item.ID = res.ResultData.ID
          item.UpID = res.ResultData.ID
          item.TravelerID = res.ResultData.TravelerID
          item.IsRequiredAuthorizationCode = res.ResultData.IsRequiredAuthorizationCode
          this.$toast(this.$t('AddSucceed'))
          this.$refs.PassengerDetails && this.$refs.PassengerDetails.close('reset')
          this._sendEmitMessage(item)
        })
      }
    },

    /** 触发回调 更新父级数据 */
    _sendEmitMessage(item) {
      this.$emit('delegate', {...item})
      console.log('乘客: ', this.currentDetails)
      if (!this.isClose) {
        this.close('reset')
      }
    },

    /** 移除 */
    _delete() {
      this.$alert({
        type: 'new',
        content: this.$t('AreYouSureToRemoveItFromTheFrequentTravellerList'),
        cancelTxt: this.$t('Cancel'),
        confirmFn: () => {
          let params = {
            TravelerID: this.currentDetails.TravelerID,
            TravelType: this.currentDetails.TravelType
          }
          kpiFrequentTravelerDelete(params).then((res) => {
            console.log('移除: ', res)
            if (res.ResultData) {
              this.$emit('delegateWithDelete', this.currentDetails.index)
              this.close('reset')
            } else {
              this.$toast(this.$t('RemovalFailedPleaseTryAgainLater'))
            }
          })
        }
      })
    },

    /**
     * 设置默认国籍
     */
    _setDefaultNation() {
      console.log('加载默认国籍')
      if (this.chinaNation.Code && (!this.currentDetails.Nation || this.currentDetails.Nation.Code !== 'CN')) {
        this.currentDetails.Nation = {
          ...this.chinaNation
        }
      }
    },

    /** 姓名填写说明 */
    _openNameExplain() {
      this.$refs.NameExplain.open()
    },

    _cloneFun(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
  },
  components: {
    HsButton,
    DetailsSubmitNoticeInfo,
    DetailsNoticeInfo,
    DetailsTravellerCard,
    DetailsCompanyInfo,
    DetailsOtherInfo,
    DetailsNameInfo,
    NameInfo,
    NameExplain,
    HsScroll,
    CHeader
  },
}
</script>

<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="show">
      <c-header
          class="header"
          className="c-header-12"
          :title="powerDetails.title"
          leftIcon1="icons_24pt_back.svg"
          :leftFn1="close"
      >
        <div slot="right" class="c-header-right">
          <p @click="_openNameExplain">{{ $t("FillingGuide") }}</p>
        </div>
      </c-header>

      <!--{preventDefault: false} 解决点击输入框无法失去焦点问题-->
      <hs-scroll ref="refTableView" class="table-view" :data="[details]" :options="{preventDefault: false}">
        <ul>
          <li style="height: 12px;"></li>

          <!--姓名、证件信息-->
          <details-name-info
            ref="refDetailsNameInfo"
            :currentDetails.sync="currentDetails"
            :XOrder="XOrder"
            :details="details"
            :powerDetails="powerDetails"
            :OrderBusinessType="OrderBusinessType"
            :credential.sync="credential"
            :ExpirationTime="ExpirationTime"
            :credentialList.sync="credentialList"
            :submitChecked="submitChecked"
            :isNotShowNickName="isNotShowNickName"
          />

          <!--其他信息-->
          <details-other-info
              ref="refDetailsOtherInfo"
              :currentDetails.sync="currentDetails"
              :XOrder="XOrder"
              :details="details"
              :powerDetails="powerDetails"
              :OrderBusinessType="OrderBusinessType"
              :credential="credential"
              :credentialList.sync="credentialList"
              :submitChecked="submitChecked"
              @updateGenBirNatWithCardNo="_setBirthdayAndGender"
          />

          <!--单位信息-->
          <details-company-info
              ref="refDetailsCompanyInfo"
              v-if="Number(currentDetails.TravelType) === 0"
              :currentDetails.sync="currentDetails"
              :XOrder="XOrder"
              :details="details"
              :powerDetails="powerDetails"
              :OrderBusinessType="OrderBusinessType"
              :submitChecked="submitChecked"
          />

          <!--常旅客卡-->
          <details-traveller-card
              v-if="powerDetails.showCard || powerDetails.showHotelCard"
              :currentDetails.sync="currentDetails"
              :powerDetails="powerDetails"
          />

          <!--通知-->
          <details-notice-info
              v-if="OrderBusinessType !== 0 && OrderBusinessType !== 15 && OrderBusinessType !== 17 && OrderBusinessType !== 10006"
              :currentDetails.sync="currentDetails"
              :powerDetails="powerDetails"
              :OrderBusinessType="OrderBusinessType"
          />

          <!--提交须知、删除常旅客-->
          <details-submit-notice-info
              :class="detailsSubmitNoticeInfoClass"
              :value.sync="isReadAndAgree"
              :currentDetails.sync="currentDetails"
              :powerDetails="powerDetails"
              :OrderBusinessType="OrderBusinessType"
              @delete="_delete"
          />

          <div style="height: 100px"></div>
        </ul>
      </hs-scroll>

      <footer>
        <hs-button width="100%" height="36px" font-size="14px" type="full-square" @click="_localCheck">{{ $t('SaveInfo') }}</hs-button>
      </footer>

      <!-- 姓名填写说明 -->
      <nameExplain ref="NameExplain"></nameExplain>
    </div>
  </transition>
</template>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child{
  @extend .flex-column;
  @extend .flex-start;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: $color_gray_background_0;
  z-index: 9;
  .header{
    flex-shrink: 0;
  }
  .c-header-right{
    @extend .hs-font-body;
    color: $color_black_600;
    word-break: break-all;
    text-align: center;
  }
  .table-view {
    width: 100%;
    height: calc(100% - 48px);
    overflow: hidden;
    background-color: $color_gray_background_0;
  }
  > footer {
    @extends .flex-between;
    width: 100%;
    padding: 13px 16px;
    background: $color_white;
    box-shadow: 0px -4px 8px 0px rgba(44, 3, 3, 0.04);
    position: relative;
    .hs-button {
      background: $color_theme_300;
      border-radius: 8px;
      font-weight: 500;
    }
  }
}
</style>
